const Stages = [
  { name: "rings", time: 0 },
  { name: "thickness", time: 9 },
  { name: "trunk", time: 15 },
  { name: "done", time: 22 },
];

export default Stages;
